import persistState from 'redux-localstorage';

const paths = ['userProfile', 'channelInfo'];
const key = 'geauxnetwork_storage';

const localStorage = () => persistState(paths, { key });

export { localStorage };
